<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-size-100">
				<device-add-form :deviceTypes="deviceTypes" @added="getDevices"></device-add-form>
			</div>
		</div>
		<div class="md-layout relative" style="z-index: 0;">
			<div class="md-layout-item md-size-100">
				<device-edit-form :devices="devices"
                    @updated="getDevices" @deleted="getDevices"></device-edit-form>
			</div>
		</div>
	</div>
</template>

<script>
// Components
import DeviceAddForm from "@/pages/Sites/Devices/components/DeviceAddForm";
import DeviceEditForm from "@/pages/Sites/Devices/components/DeviceEditForm";

export default {
	name: "DevicesEdit",
	components: { DeviceAddForm, DeviceEditForm },
	data() {
		return {
			devices: [],
			deviceTypes: [],
		}
	},
	methods: {
		async getDevices() {
			const devices = await this.$store.dispatch('devices/getDevices', { id: this.$route.params.idSite })
			const deviceTypes = await this.$store.dispatch('devices/fetchAllDeviceTypes')
			this.devices = devices.data
			this.deviceTypes = deviceTypes.data
		},
		goBack() {
			this.$router.back()
		}
	},
	mounted() {
		this.getDevices()
	}
}
</script>

<style scoped>

</style>
